import {default as Patentes} from './patentes/routes'
import {default as TiposPolicia} from './tipos-policia/routes'
import {default as Policial} from './policial/routes'
import {default as UnidadePolicial} from './unidade-policial/routes'

export default [
  ...Patentes,
  ...TiposPolicia,
  ...Policial,
  ...UnidadePolicial
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/policiais/routes.js